export default {
  headerGeneral: 'Všeobecné vlastnosti',
  headerSimulationValues: 'Simulačné hodnoty',
};
